module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_LockOpen_16"],"path":[{"$":{"d":"M12,7V4A3,3,0,0,0,9,1H7A3,3,0,0,0,4,4V5H6V4A1,1,0,0,1,7,3H9a1,1,0,0,1,1,1V7H2v7H14V7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_LockOpen_16.svg
// module id = vGqF
// module chunks = 1